<template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="headline font-weight-bold mb-4">
            Administrar costos
          </div>
          <v-breadcrumbs
            divider=">"
            :items="breadcrumbItems"
            class="pa-0"
          ></v-breadcrumbs>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-text class="d-flex justify-space-between">
              <span class="title">
                Configurar costos de escalas generales
              </span>
              <v-btn
                color="primary"
                icon
                @click="openDialogAddonScale({})"
              >
                <v-icon>
                  tune
                </v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-data-table
              :headers="dataTable.headers"
              :items="dataTable.items"
              class="elevation-1"
              pagination.sync="pagination"
              item-key="organization_id"
              :loading="loading"
            >
              <template v-slot:item.name="{ item }">
                <v-tooltip right color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-on="on" left :color="getStatusObject(item.status).color">
                      {{ getStatusObject(item.status).icon }}
                    </v-icon>
                  </template>
                  <span>{{ getStatusObject(item.status).text }}</span>
                </v-tooltip>
                {{ item.name }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  @click="openDialogAddonScale({
                    organizationId: item.id
                  })"
                >
                  <v-icon>settings</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <DialogAddonScales
        :display="dialogAddonScales.display"
        :organizationId="dialogAddonScales.organization_id"
        @close="closeDialogAddonScale"
      />
    </v-container>
  </template>
  
  <script>
  import DialogAddonScales from '@/components/Addon/DialogAddonScales'
  import { mapActions, mapState } from 'vuex'
  import { AddonScalesService } from '@/services/addonScales.service'
  import organizationMixin from '@/mixins/organization'
  
  export default {
    name: 'ManageCosts',
    components: {
      DialogAddonScales
    },
    mixins: [organizationMixin],
    data () {
      return {
        breadcrumbItems: [
          {
            text: 'Addons',
            disabled: false
          },
          {
            text: 'Administrar costos',
            disabled: true,
            href: ''
          }
        ],
        dataTable: {
          headers: [
            {
              text: 'ID',
              align: 'left',
              sortable: false,
              value: 'id',
              width: 0
            },
            {
              text: 'Organización',
              align: 'left',
              sortable: false,
              value: 'name'
            },
            {
              text: '',
              align: 'center',
              sortable: false,
              value: 'actions',
              width: 0
            }
          ],
          items: []
        },
        dialogAddonScales: {
          display: false,
          organization_id: null
        }
      }
    },
    computed: {
      ...mapState({
        organizations: state => state.organizations
      })
    },
    async created () {
      await this.getData()
      await this.getAddons()
      await this.getAllOrganizations()
    },
    methods: {
      ...mapActions({
        getAllOrganizations: 'organization/getAll',
        getAddons: 'organization/getAddons'
      }),
      openDialogAddonScale ({ organizationId }) {
        this.dialogAddonScales.organization_id = organizationId
        this.dialogAddonScales.display = true
      },
      closeDialogAddonScale () {
        this.getData()
        this.dialogAddonScales.display = false
        this.dialogAddonScales.organization_id = null
      },
      async getData () {
        try {
          this.loading = true
          const data = (await AddonScalesService.getByOrganizations({})).data
          this.dataTable.items = data
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      }
    }
  }
  </script>
  